import React from 'react';
import VocabRight from './VocabRight';
import ErrorBoundary from './components/ErrorBoundary';
import A2AServerToggle from './components/A2AServerToggle';

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <VocabRight />
        <A2AServerToggle />
      </ErrorBoundary>
    </div>
  );
}

export default App;
